module.exports = __webpack_public_path__ + "img/logo-uic.4cdaa02f.png";